import { createFileRoute } from "@tanstack/react-router";

import { MyAccountHubPage } from "@/views/account/hub";

export const Route = createFileRoute("/_authenticated/account/")({
  component: MyAccountHubPage,
});
